import { List } from '@material-ui/core';
import React, { ReactElement } from 'react';
import { ContentTableItem } from '../../atoms';

export interface IContentTableListProps {
	contentList: IContentTableListItem[];
	showArrows?: boolean;
	selectedId?: string;
	onClick?: (region: IContentTableListItem) => void;
}

export interface IContentTableListItem {
	id: string;
	name: string;
}

export function ContentTableList(props: IContentTableListProps): ReactElement {
	const { contentList, showArrows, selectedId, onClick: loadList } = props;

	function handleOnClick(item: IContentTableListItem): void {
		if (loadList) {
			loadList(item);
		}
	}

	return (
		<List className="content-table-list">
			{contentList.map((item: IContentTableListItem) => (
				<ContentTableItem
					key={item.id}
					name={item.name}
					showArrow={showArrows}
					selected={selectedId === item.id}
					onClick={() => handleOnClick(item)}
				/>
			))}
		</List>
	);
}
